import { useTranslation } from 'react-i18next';

import { DARK } from 'constants/colors';

import ViewListIcon from '@mui/icons-material/ViewList';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { Tooltip } from 'components/shared';

import { useEditPageContext } from '../EditPage';

interface Props {
  closeInnerView?: () => void;
  href?: string;
}

const BackToListButton: React.FC<Props> = ({ closeInnerView, href }) => {
  const { t } = useTranslation('common');
  const { isEditable } = useEditPageContext();

  return (
    <Tooltip title={t('backToList')}>
      <ToggleButtonGroup
        exclusive
        size="small"
        onChange={closeInnerView && closeInnerView}
        aria-label="Platform"
        disabled={isEditable}
      >
        <ToggleButton
          value="list"
          aria-label="list"
          {...(href ? { href } : {})}
        >
          <ViewListIcon sx={{ color: DARK, opacity: isEditable ? 0.5 : 1 }} />
        </ToggleButton>
      </ToggleButtonGroup>
    </Tooltip>
  );
};

export default BackToListButton;
